import { Navigate, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Layout } from './components/Layout';
import { ComparePage } from './pages/ComparePage';
import { ConnectorsPage } from './pages/ConnectorsPage';
import { IncidentsPage } from './pages/IncidentsPage';
import { LoginPage } from './pages/LoginPage';
import { MisPage } from './pages/MisPage';
import { PlantPage } from './pages/PlantPage';
import { PortfolioPage } from './pages/PortfolioPage';
import { useAuth } from './lib/auth';

export function App() {
  const { t } = useTranslation();
  const { stage, me } = useAuth();

  if (stage === 'loading') {
    return <p className="centered muted">{t('app.loading')}</p>;
  }
  if (stage !== 'ready' || !me?.active_tenant_id) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<PortfolioPage />} />
        <Route path="/plants/:plantId" element={<PlantPage />} />
        <Route path="/mis" element={<MisPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/incidents" element={<IncidentsPage />} />
        <Route path="/connectors" element={<ConnectorsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
